import RFIIssued_uischema from "./UISchemas/RFIIssued_uischema";
import Add_Ad_Hoc_uischema from "./UISchemas/Add_Ad_Hoc_Uischema";
import Add_Ad_Hoc_uischema_9142A from "./UISchemas/9142A/Add_Ad_Hoc_Uischema";
import NOD_uischema from "./UISchemas/NOD_uischema";
import NRM_uischema from "./UISchemas/NRM_uischema";
import Withdraw_uischema from "./UISchemas/Withdraw_uischema";
import Withdraw_uischema_9035 from "./UISchemas/9035/Withdraw_uischema";
import {
  RFIIssued_uischema as RFIIssued_uischema_9089,
  Withdraw_uischema as Withdraw_uischema_9089,
  WithdrawFromAppeals_uischema as WithdrawFromAppeals_uischema_9089,
  RequestExtension_uischema as RequestExtension_uischema_9089,
  RequestExtension_Appeals_uischema,
  RequestForReconsideration_uischema as RequestForReconsideration_uischema_9089,
  AddAdHocDocuments_uischema as AddAdHocDocuments_uischema_9089,
  SRResponse_uischema,
} from "./UISchemas/9089";
import UploadRebuttalEvidence_uischema from "./UISchemas/UploadRebuttalEvidence_uischema.js";
import Upload_Recruitment_Report from "./UISchemas/Upload_Recruitment_Report_uischema";
import RequestRedetermination_uischema from "./UISchemas/RequestRedetermination_uischema";
import Request_CDR_uischema from "./UISchemas/Request_CDR_uischema";
import RequestAppeal_uischema from "./UISchemas/RequestAppeal_uischema";
import AbandonTerminate_uischema from "./UISchemas/Abandon_Terminate_uischema";
import RequestExtension_uischema from "./UISchemas/RequestExtension_uischema";
import RequestForReview_uischema from "./UISchemas/RequestForReview_uischema";
import AuditResponse_uischema from "./UISchemas/AuditResponse_uischema.js";
import Post_Cert_uischema from "./UISchemas/9142B/Post_Cert_uischema.js";
import RequestExtension_uischema_9142C from "./UISchemas/9142C/RequestExtensionRecruitmentReport_uischema.js";
import NODExtensionRequest_uischema_9142C from "./UISchemas/9142C/NODExtensionRequest_uischema.js";

const extraKeyString = (formType, status, visaType, isLinked) => {
  switch (formType) {
    case "790A":
      return isLinked ? "" : "Unlinked";
    case "9141":
      return visaType === "H-2B" ? "H-2B" : "";
    default:
      return "";
  }
};

const dateKeyString = (is_postdetermination_available, status) => {
  const postdetermined_statuses = [
    "REDETERMINATION AFFIRMED",
    "REDETERMINATION MODIFIED",
    "DETERMINATION ISSUED",
    "NOD ISSUED",
    "DENIED",
    "PARTIAL CERTIFICATION",
    "CERTIFIED",
    "CERTIFIED - EXPIRED",
    "RECONSIDERATION APPEALS",
  ];
  let possible_unavailable =
    !is_postdetermination_available &&
    postdetermined_statuses.indexOf(status.trim()) > -1
      ? "UNAVAILABLE"
      : "";
  if (is_postdetermination_available === null) {
    possible_unavailable = "";
  }
  return possible_unavailable;
};

const caseDetailFormActionResolver = (
  formVersionId,
  formType,
  status,
  visaType,
  isLinked,
  is_postdetermination_available
) => {
  const extra = extraKeyString(formType, status, visaType, isLinked);
  const dateKey = dateKeyString(is_postdetermination_available, status);
  let key = formType.trim() + status.trim().toUpperCase() + extra + dateKey;
  const formActionResolver = {
    "9142CIN PROCESS": ["Withdraw", "Add ad hoc documents"],
    "9142CACCEPTED - PENDING RECRUITMENT": [
      "Add ad hoc documents",
      "Recruitment Report",
      "Request Recruitment Report Extension_9142C",
      "Withdraw",
    ],
    "9142CRECRUITMENT REPORT EXTENSION REQUESTED": [
      "Add ad hoc documents",
      "Recruitment Report",
      "Withdraw",
    ],
    "9142CNOD ISSUED": ["Add ad hoc documents", "Withdraw", "NOD Response", "NOD Extension Request_9142C"],
    "9142CNOD EXTENSION REQUESTED": ["Add ad hoc documents", "Withdraw", "NOD Response"],
    "9142CPARTIAL CERTIFICATION": ["Add ad hoc documents"],
    "9141RFI ISSUED": ["RFI response", "Withdraw"],
    "9141RFI ISSUEDH-2B": ["RFI response", "Withdraw"],
    "9141IN PROCESS": ["Withdraw"],
    "9141IN PROCESSH-2B": ["Withdraw"],
    "9141DETERMINATION ISSUEDH-2B": ["Request CDR"],
    "9141DETERMINATION ISSUEDH-2BUNAVAILABLE": [
      { name: "Request CDR", disabled: true },
    ],
    "9141DETERMINATION ISSUED": ["Request Redetermination"],
    "9141DETERMINATION ISSUEDUNAVAILABLE": [
      { name: "Request Redetermination", disabled: true },
    ],
    "9141REDETERMINATION AFFIRMED": ["Request CDR"],
    "9141REDETERMINATION MODIFIED": ["Request CDR"],
    "9141REDETERMINATION AFFIRMEDUNAVAILABLE": [
      { name: "Request CDR", disabled: true },
    ],
    "9141REDETERMINATION MODIFIEDUNAVAILABLE": [
      { name: "Request CDR", disabled: true },
    ],
    // "9141CRFI ISSUED": ["RFI response"],
    "9142BIN PROCESS": ["Withdraw", "Add ad hoc documents"],
    "9142BNOD ISSUED": ["Withdraw", "Add ad hoc documents", "NOD Response"],
    "9142BACCEPTED - PENDING RECRUITMENT": [
      "Withdraw",
      "Add ad hoc documents",
      "Recruitment Report",
    ],
    "9142BPARTIAL CERTIFICATION": [
      "Add ad hoc documents",
      "Upload Abandonment or Termination Notice",
      "Post-Certification",
    ],
    "9142BFULL CERTIFICATION": [
      "Upload Abandonment or Termination Notice",
      "Post-Certification",
    ],
    "790AIN PROCESSUnlinked": ["Withdraw"],
    "790ANOD ISSUEDUnlinked": ["Withdraw"],
    "790AACCEPTED - PENDING RECRUITMENTUnlinked": ["Withdraw"],
    "790ADENIEDUnlinked": ["Withdraw"],
    "790AAPPROVEDUnlinked": ["Withdraw"],
    "790AJO APPROVEDUnlinked": ["Withdraw"],
    "790AJO DENIEDUnlinked": ["Withdraw"],
    "790AAVAILABLE FOR 9142A LINKINGUnlinked": ["Withdraw"],
    "9142AIN PROCESS": ["Withdraw", "Add ad hoc documents_9142A"],
    "9142AACCEPTED - PENDING RECRUITMENT": [
      "Withdraw",
      "Recruitment Report",
      "Add ad hoc documents_9142A",
    ],
    "9142ANOD ISSUED":
      formVersionId === 2
        ? ["Withdraw", "NOD Response", "Add ad hoc documents_9142A"]
        : [
            "Withdraw",
            "NOD Response",
            "Add ad hoc documents_9142A",
            "Request Appeal",
          ],
    "9142ANOD ISSUEDUNAVAILABLE": [
      "Withdraw",
      "NOD Response",
      "Add ad hoc documents_9142A",
      { name: "Request Appeal", disabled: true },
    ],
    "9142ANRM ISSUED": [
      "Withdraw",
      "NRM Response",
      "Add ad hoc documents_9142A",
    ],
    "9142ADENIED": ["Request Appeal"],
    "9142ADENIEDUNAVAILABLE": [{ name: "Request Appeal", disabled: true }],
    "9142APARTIAL CERTIFICATION": [
      "Request Appeal",
      // "Upload Abandonment or Termination Notice",
    ],
    "9142APARTIAL CERTIFICATIONUNAVAILABLE": [
      { name: "Request Appeal", disabled: true },
      // { name: "Upload Abandonment or Termination Notice", disabled: true },
    ],
    "9142AFULL CERTIFICATION": ["Upload Abandonment or Termination Notice"],
    "9035IN PROCESS": ["Withdraw_9035"],
    "9035CERTIFIED": ["Withdraw_9035"],

    "9089ANALYST REVIEW": ["Withdraw_9089", "Add ad hoc documents_9089"],
    "9089ANALYST REVIEWUNAVAILABLE": [
      "Withdraw_9089",
      { name: "Add ad hoc documents_9089", disabled: true },
    ],
    "9089AUDIT REVIEW": ["Withdraw_9089", "Add ad hoc documents_9089"],
    "9089AUDIT REVIEWUNAVAILABLE": [
      "Withdraw_9089",
      { name: "Add ad hoc documents_9089", disabled: true },
    ],
    "9089PENDING AUDIT RESPONSE": [
      "Withdraw_9089",
      "Audit Response",
      {
        name: "Request Extension_9089",
      },
    ],
    "9089PENDING AUDIT RESPONSEUNAVAILABLE": ["Withdraw_9089"],
    "9089AUDIT - RFI ISSUED": [
      "Withdraw_9089",
      "RFI Response_9089",
      {
        name: "Request Extension_9089",
      },
    ],
    "9089RFI ISSUED": [
      "Withdraw_9089",
      "RFI Response_9089",
      {
        name: "Request Extension_9089",
      },
    ],
    "9089DENIED": [
      "Request for Reconsideration",
      "Request for Review",
      {
        name: "Request Extension_9089",
      },
    ],
    "9089DENIEDUNAVAILABLE": [
      { name: "Request for Reconsideration", disabled: true },
      { name: "Request for Review", disabled: true },
      { name: "Request Extension_9089", disabled: true },
    ],
    "9089RECONSIDERATION APPEALS": [
      "Withdraw From Appeals",
      "Add ad hoc documents_9089",
    ],
    "9089RECONSIDERATION APPEALSUNAVAILABLE": ["Withdraw From Appeals"],
    "9089RECONSIDERATION APPEALS - RFI ISSUED": [
      "Withdraw From Appeals",
      "RFI Response_9089",
      {
        name: "Request Extension_9089Appeals",
      },
    ],
    "9089REQUEST FOR REVIEW": ["Withdraw_9089"],
    "9089NORD ISSUED": [
      "Withdraw From Appeals",
      { name: "Request for Review", altLabel: "Continue to BALCA" },
      {
        name: "Request Extension_9089Appeals",
      },
    ],
    "9089CERTIFIED": ["Upload Rebuttal Evidence"],
    "9089CERTIFIED - EXPIRED": ["Upload Rebuttal Evidence"],
    "9089SR - CORRESPONDENCE ISSUED": [
      "SR Response",
      {
        name: "Request Extension_9089",
      },
      "Withdraw_9089",
    ],
    "9089SR - CORRESPONDENCE ISSUED - EXTENSION REQUESTED": [
      "SR Response",
      { name: "Request Extension_9089", disabled: true },
      "Withdraw_9089",
      "Add ad hoc documents_9089",
    ],
    "9089SR - CORRESPONDENCE ISSUED - EXTENSION REQUESTEDUNAVAILABLE": [
      "SR Response",
      { name: "Request Extension_9089", disabled: true },
      "Withdraw_9089",
      { name: "Add ad hoc documents_9089", disabled: true },
    ],
    "9089SUPERVISED RECRUITMENT": ["Withdraw_9089"],
  };

  return formActionResolver[key];
};

const CaseDetailISchemaResolver = (
  formName,
  caseNumber,
  internalStatus,
  formId
) => {
  const profileUISchemaList = {
    "Request Redetermination": RequestRedetermination_uischema,
    "RFI response": RFIIssued_uischema(caseNumber),
    "Add ad hoc documents": Add_Ad_Hoc_uischema,
    "Add ad hoc documents_9142A": Add_Ad_Hoc_uischema_9142A,
    "NOD Response": NOD_uischema(caseNumber),
    "NOD Extension Request_9142C": NODExtensionRequest_uischema_9142C(caseNumber),
    "NRM Response": NRM_uischema,
    "Recruitment Report": Upload_Recruitment_Report(caseNumber),
    "Request CDR": Request_CDR_uischema(caseNumber),
    Withdraw: Withdraw_uischema,
    Withdraw_9035: Withdraw_uischema_9035,
    Withdraw_9089: Withdraw_uischema_9089,
    "Withdraw From Appeals": WithdrawFromAppeals_uischema_9089,
    "RFI Response_9089": RFIIssued_uischema_9089(caseNumber),
    "Request Appeal": RequestAppeal_uischema,
    "Audit Response": AuditResponse_uischema(formId),
    "Upload Abandonment or Termination Notice":
      AbandonTerminate_uischema(caseNumber),
    "Request Recruitment Report Extension_9142C": RequestExtension_uischema_9142C(caseNumber),
    "Request Extension_9089": RequestExtension_uischema_9089(caseNumber),
    "Request Extension_9089Appeals":
      RequestExtension_Appeals_uischema(caseNumber),
    "SR Response": SRResponse_uischema(caseNumber, internalStatus),
    "Request for Reconsideration": RequestForReconsideration_uischema_9089,
    "Request for Review": RequestForReview_uischema(formId),
    "Upload Rebuttal Evidence": UploadRebuttalEvidence_uischema(caseNumber),
    "Add ad hoc documents_9089": AddAdHocDocuments_uischema_9089,
    "Post-Certification": Post_Cert_uischema(caseNumber),
  };
  return profileUISchemaList[formName] || RFIIssued_uischema;
};

export { CaseDetailISchemaResolver, caseDetailFormActionResolver };
